export type SocialLinkField = 'facebookUrl' | 'instagramUrl' | 'tiktokUrl' | 'websiteUrl';

type ProfileRule = { host: string; pathPrefix: string };

const PROFILE: Record<Exclude<SocialLinkField, 'websiteUrl'>, ProfileRule> = {
  facebookUrl: { host: 'facebook.com', pathPrefix: '' },
  instagramUrl: { host: 'instagram.com', pathPrefix: '' },
  tiktokUrl: { host: 'tiktok.com', pathPrefix: '@' },
};

const HANDLE_RE = /^[A-Za-z0-9._-]{1,60}$/;

function profileHandle({ host, pathPrefix }: ProfileRule, stored: string): string | null {
  let url: URL;
  try {
    url = new URL(stored);
  } catch {
    return null;
  }
  if (url.hostname.toLowerCase().replace(/^(www|m)\./, '') !== host) return null;
  const segments = url.pathname.split('/').filter(Boolean);
  if (segments.length !== 1) return null;
  if (!segments[0].startsWith(pathPrefix)) return null;
  const handle = segments[0].slice(pathPrefix.length);
  if (handle.endsWith('.php') || !HANDLE_RE.test(handle)) return null;
  return `@${handle}`;
}

export function socialLinkDisplay(
  field: SocialLinkField,
  stored: string | null | undefined,
): string {
  if (!stored) return '';
  if (field === 'websiteUrl') return stored;
  return profileHandle(PROFILE[field], stored) ?? stored;
}

export function socialLinkToSave(
  field: SocialLinkField,
  shown: string,
  stored: string | null | undefined,
): string | null {
  const value = shown.trim();
  if (!value) return null;
  return stored && value === socialLinkDisplay(field, stored) ? stored : value;
}
